<ng-select
  [items]="options"
  bindValue="value"
  [(ngModel)]="internalValue"
  [clearable]="false"
  (change)="onValueChange($event)"
  [id]="id"
></ng-select>
